<template>
    <v-form ref="ResetPasswordConfirmationSentForm" v-model="valid" lazy-validation>
        <div class="reset-password__success">
            <div class="reset-password__success-message">{{loginConstants.RESET_PASSWORD_CONFIRMATION_MESSAGE}}</div>
        </div>
        <v-card-actions>
            <v-layout row wrap>
                <v-btn large 
                       id="return_to_home_btn"
                       data-qe-id="return_to_home_btn"
                       block
                       color="ypo_blue"
                       class="white--text"
                       @click="returnToLogin()">
                    {{loginConstants.LOGIN}}
                </v-btn>
            </v-layout>
        </v-card-actions>
    </v-form>
</template>
<script>
    import { loginConstants } from '../login.constants';

    export default {
        name: 'ResetPasswordConfirmationSent',
        data: () => ({
            loginConstants,
            valid: true,
            componentNames: loginConstants.componentNames,
        }),
        props: {
            changeCardState: Function,
            toggleProgressIndicator: Function,
            isSubmitting: Boolean,
            returnToLogin: Function,
        },
    };
</script>
<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .reset-password {
        &__title

    {
        padding: 5px 10px 20px 5px;
        font-size: 16px;
        color: $black;
        opacity: 0.9;
    }

    &__success {
        padding: 5px 10px 20px 5px;
        font-size: 16px;

        &-destination
        {
            color: $ypo-blue-secondary;
        }
    }

    }

    .v-btn__content {
        @include breakpoint(xs) {
            font-size: 12px !important;
        }
    }

    .v-card__actions {
        padding-right: 0 !important;

        @include breakpoint(xs) {
            padding: 0 !important;
        }
    }
</style>
